import type { PropertyPreviewProps } from "@firecms/core";

export type EventInvitationEmailSentPreviewProps = {
  notSentLabel: string;
  locale: string;
};

const toDate = (value: unknown): Date | null => {
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return value;
  }
  if (
    value != null &&
    typeof value === "object" &&
    "toDate" in value &&
    typeof value.toDate === "function"
  ) {
    const date = value.toDate();
    return date instanceof Date && !Number.isNaN(date.getTime()) ? date : null;
  }
  if (typeof value === "string" || typeof value === "number") {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  }
  return null;
};

export function EventInvitationEmailSentPreview({
  value,
  customProps,
}: PropertyPreviewProps<Date, EventInvitationEmailSentPreviewProps>) {
  const date = toDate(value);
  if (!date) {
    return (
      <span className="text-sm text-surface-400">
        {customProps?.notSentLabel ?? "Not sent"}
      </span>
    );
  }

  const label = new Intl.DateTimeFormat(customProps?.locale, {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(date);

  return <span className="text-sm">{label}</span>;
}
